import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import LoginPage from "@/pages/LoginPage";
import AuthCallback from "@/pages/AuthCallback";
import AppShell from "@/pages/AppShell";
import InboxPage from "@/pages/InboxPage";
import ConnectionsPage from "@/pages/ConnectionsPage";
import ContactsPage from "@/pages/ContactsPage";
import UsersPage from "@/pages/UsersPage";
import ReportsPage from "@/pages/ReportsPage";
import QuickRepliesPage from "@/pages/QuickRepliesPage";
import SchedulerPage from "@/pages/SchedulerPage";
import DepartmentsPage from "@/pages/DepartmentsPage";
import SettingsPage from "@/pages/SettingsPage";
import CrmPage from "@/pages/CrmPage";
import AgendaPage from "@/pages/AgendaPage";
import PlatformPage from "@/pages/PlatformPage";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-muted-foreground">Carregando…</div>
    </div>
  );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Router />
      </BrowserRouter>
    </AuthProvider>
  );
}

function Router() {
  const location = useLocation();
  // Synchronous hash check prevents race with ProtectedRoute/AuthProvider
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/" element={<Protected><AppShell /></Protected>}>
        <Route index element={<Navigate to="/inbox" replace />} />
        <Route path="inbox" element={<InboxPage />} />
        <Route path="inbox/:chatId" element={<InboxPage />} />
        <Route path="connections" element={<ConnectionsPage />} />
        <Route path="contacts" element={<ContactsPage />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="reports" element={<ReportsPage />} />
        <Route path="quick-replies" element={<QuickRepliesPage />} />
        <Route path="scheduler" element={<SchedulerPage />} />
        <Route path="departments" element={<DepartmentsPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="crm" element={<CrmPage />} />
        <Route path="agenda" element={<AgendaPage />} />
        <Route path="platform" element={<PlatformPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
